'use client';

import { ReactNode, useEffect, useState } from 'react';
import { ThemeProvider, Theme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

export interface CustomThemeProviderProps {
  children: ReactNode;
  theme?:
    | 'brainpool'
    | 'tunedd'
    | 'tuneddWeb'
    | 'salesDemo'
    | 'forstack'
    | 'daisy'
    | string
    | Theme;
}

export function CustomThemeProvider({ children, theme = 'brainpool' }: CustomThemeProviderProps) {
  const [loadedTheme, setLoadedTheme] = useState<Theme | null>(() =>
    typeof theme === 'object' && theme !== null && 'palette' in theme ? (theme as Theme) : null
  );

  useEffect(() => {
    if (typeof theme === 'object' && theme !== null && 'palette' in theme) {
      setLoadedTheme(theme as Theme);
      return;
    }

    const loadTheme = async () => {
      let themeModule;
      switch (theme) {
        case 'brainpool':
          themeModule = await import('./brainpool/brainpool');
          break;
        case 'tunedd':
          themeModule = await import('./tunedd/tunedd');
          break;
        case 'tuneddWeb':
          themeModule = await import('./tunedd/tunedd-web');
          break;
          break;
        case 'forstack':
          themeModule = await import('./brainpool/forstack');
          break;
        case 'daisy':
          themeModule = await import('./brainpool/daisy');
          break;
        default:
          themeModule = await import('./brainpool/brainpool'); // Fallback to default theme
      }
      setLoadedTheme(themeModule.default);
    };

    loadTheme();
  }, [theme]);

  if (!loadedTheme) {
    return null;
  }

  return (
    <ThemeProvider theme={loadedTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export default CustomThemeProvider;
